import industry from './service';
import customer from './customer'
import writeLetters from './writeLetters'
import feedback from './feedback'
import finance from './finance'
import sitmap from './sitmap'
export default {
    industry,
    customer,
    writeLetters,
    feedback,finance,
    sitmap
};
